import { Box, Dialog, DialogContent, DialogTitle, Paper, TextField } from "@mui/material"
import { styled } from "@mui/material/styles"

export const StyledContainer = styled(Box)(({ theme }) => ({
  height: "100%",
  display: "flex",
  flexDirection: "column"
}))

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    maxWidth: "800px",
    width: "90%",
    maxHeight: "80vh"
  }
}))

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: theme.spacing(2, 3),
  borderBottom: `1px solid ${theme.palette.divider}`
}))

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: theme.spacing(3)
}))

export const StyledVehicleCard = styled(Paper)(({ theme }) => ({
  marginBottom: theme.spacing(1)
}))

export const StyledFormField = styled(TextField)(({ theme }) => ({
  marginBottom: theme.spacing(3)
}))

export const StyledButtonContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(2),
  justifyContent: "space-between",
  marginTop: theme.spacing(3),
  paddingTop: theme.spacing(3),
  borderTop: `1px solid ${theme.palette.divider}`
}))

export const StyledVehicleList = styled(Box)(({ theme }) => ({
  maxHeight: "400px",
  minHeight: "400px",
  overflowY: "auto",
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(2)
}))
